import { render, staticRenderFns } from "./vodPoint.vue?vue&type=template&id=32c6e226&scoped=true"
import script from "./vodPoint.vue?vue&type=script&lang=js"
export * from "./vodPoint.vue?vue&type=script&lang=js"
import style0 from "./vodPoint.vue?vue&type=style&index=0&id=32c6e226&prod&scoped=true&lang=css"
import style1 from "./vodPoint.vue?vue&type=style&index=1&id=32c6e226&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c6e226",
  null
  
)

export default component.exports